import React from 'react';
import icFolderEmpty from 'assets/svg/folder_empty.svg';
import { Container, Content, Image, Title } from './styled';

const EmptyList = ({
  className,
  title = 'Sorry, no result found.',
  content,
  imgWidth = 234,
  imgHeight = 234,
  img
}) => {
  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement(Image, {
    draggable: false,
    width: imgWidth,
    height: imgHeight,
    src: img || icFolderEmpty
  }), /*#__PURE__*/React.createElement(Title, null, title), !!content && /*#__PURE__*/React.createElement(Content, null, content));
};

export default EmptyList;